import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import classNames from "classnames";
import actionBarStyles from "../../../general/ActionBar/ActionBar.module.scss";
import { CounterpartySelect } from "../../../counterparty/CounterpartySelect";
import { useTypedFlags } from "../../../../hooks/useTypedFlags";
import { useBulkActions } from "../useBulkActions";

interface Props {
    isBusy: boolean;
}

export const TransactionsActionBarCounterparty: React.FC<Props> = ({
    isBusy,
}) => {
    const bulkActions = useBulkActions();
    const { directory: isDirectoryEnabled } = useTypedFlags();

    if (!isDirectoryEnabled) {
        return null;
    }

    return (
        <CounterpartySelect
            onChange={(counterparty) =>
                counterparty &&
                bulkActions.updateSelected({
                    update: "counterpartyId",
                    value: counterparty.id,
                })
            }
            dropdownKey="counterpartyBulkEdit"
            allowToCreateNew
            forTransactionEditing
        >
            <OverlayTrigger
                placement="top"
                overlay={
                    <Tooltip id="action-bar-counterparty">
                        Update Vendor/Customer
                    </Tooltip>
                }
            >
                <button
                    className={classNames(actionBarStyles.button)}
                    disabled={isBusy}
                >
                    Vendor/Customer
                </button>
            </OverlayTrigger>
        </CounterpartySelect>
    );
};
